module.exports = __webpack_public_path__ + "static/culture-desktop.53af93b9.webp";